import { useState, useCallback, useEffect } from 'react';

const useCarousel = (length, intervalMs = 5000) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const next = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % length);
  }, [length]);

  const prev = useCallback(() => {
    setCurrentIndex((prev) => (prev - 1 + length) % length);
  }, [length]);

  const goTo = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  const pause = useCallback(() => setIsAutoPlaying(false), []);
  const resume = useCallback(() => setIsAutoPlaying(true), []);

  useEffect(() => {
    if (!isAutoPlaying) return;
    const id = setInterval(next, intervalMs);
    return () => clearInterval(id);
  }, [isAutoPlaying, next, intervalMs]);

  return { currentIndex, isAutoPlaying, next, prev, goTo, pause, resume };
};

export default useCarousel;
